module.exports = "\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main